// Version : 1.0.0
// Author : AGALYA

const AdvanceMemberActionType = {
	/** ***************** FETCH ADVANCE MEMBER LIST START *********************** */
	FETCH_ADVANCE_MEMBER_LIST_START: 'fetch_advance_member_list_start',
	FETCH_ADVANCE_MEMBER_LIST_SUCCESS: 'fetch_advance_member_list_success',
	FETCH_ADVANCE_MEMBER_LIST_FAILURE: 'fetch_advance_member_list_failure',
	FETCH_ADVANCE_MEMBER_LIST_RESPONSE_REST_START: 'fetch_advance_member_list_response_reset_start',
	FETCH_ADVANCE_MEMBER_LIST_RESPONSE_CHANGED: 'fetch_advance_member_list_response_changed',
	/** ***************** FETCH ADVANCE MEMBER LIST END *********************** */
};
export default AdvanceMemberActionType;
